import { Alert, Button, FormControl, FormLabel, Grid, LinearProgress, Snackbar, TextField, Typography } from "@mui/material";
import { MuiTelInput, matchIsValidTel } from "mui-tel-input";
import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { UserContext } from "../context/UserContextProvider";
import Api from "../api/Api";

const CreateSMSInvitePage = () => {
    const navigate = useNavigate();
    const [phone, setPhone] = useState('');
    const [isValidPhone, setValidPhone] = useState(true);
    const [isSending, setSending] = useState(false);
    const { user } = useContext(UserContext);
    const [earnStatus, setEarnStatus] = useState(undefined);
    const [message, setMessage] = useState(`${user.profile_name} invites you to join Tangled Social.`);
    const [validations, setValidations] = useState({ error_message: false, error_amount: false });
    const [alertState, setAlertState] = useState({ show: false, success: true, message: [] })

    useEffect(() => {
        const fetch = async () => {
            setEarnStatus(await Api.isActive('sms', user.idem_guid));
        }
        fetch();
    }, [user.idem_guid]);


    const handleCloseFormUpdateAlert = (/** @type {any} */ _event, /** @type {string} */ reason) => {
        if (reason === 'clickaway') {
            return
        }

        setAlertState({ show: false, success: true, message: [] })
    }

    const updatePhone = (/** @type { string } */ value) => {
        setValidPhone(matchIsValidTel(value))
        setPhone(value)
    }

    const sendInvite = async () => {
        try {
            setSending(true);
            const campaign = await Api.createCampaign('sms', [phone], message, user.idem_guid);
            setAlertState({ show: true, success: true, message: ['The invite was sent.'] });
            setTimeout(() => {
                navigate(`/campaing/${campaign._id}`);
            }, 750);
        } catch (e) {
            setSending(false);
            const message = ['Could not send the invite'];
            if (e?.response?.data?.error?.message) {
                message.push(e.response.data.error.message);
            }
            setAlertState({ show: true, success: false, message });
        }
    }

    if (!user || !earnStatus) {
        return <LinearProgress />;
    }

    return <Grid container spacing={2}>
        {!earnStatus.active && <Grid item xs={12}>
            <Alert severity='info' sx={{ mb: 2 }}>
                <Typography variant={'body1'}>
                    {`Your have reached the daily limit. Try again later.`}
                </Typography>
            </Alert>
        </Grid>}
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Typography variant='h6' sx={{ color: 'white' }}>
                Invite your friend and earn 100,000 mlx.
            </Typography>
        </Grid>
        <Grid item xs={12}>
            <FormControl fullWidth error={validations.error_amount}>
                <FormLabel sx={{ color: 'white' }} >Phone Number</FormLabel>
                <MuiTelInput defaultCountry="US" value={phone} onChange={updatePhone} error={!isValidPhone} />
            </FormControl>
        </Grid>
        <Grid item xs={12}>
            <FormControl fullWidth error={validations.error_message}>
                <FormLabel sx={{ color: 'white' }} >Message</FormLabel>
                <TextField value={message} onChange={e => {
                    setValidations({ ...validations, error_message: e.target.value.length === 0 })
                    setMessage(e.target.value)
                }} error={validations.error_message} />
            </FormControl>
        </Grid>
        <Grid item xs={12} justifyContent={'center'} display={'flex'}>
            <Button variant='contained' sx={{ minWidth: 200 }} onClick={sendInvite} disabled={phone === '' || !isValidPhone || isSending || !earnStatus?.active}>Send</Button>
        </Grid>
        {alertState.show && (
            <Snackbar
                open={alertState.show}
                autoHideDuration={4000}
                onClose={handleCloseFormUpdateAlert}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
            >
                <Alert
                    onClose={handleCloseFormUpdateAlert}
                    severity={alertState.success ? 'success' : 'error'}
                    variant={'filled'}
                    elevation={6}
                    sx={{ width: '100%' }}
                >
                    {alertState.message.map((message, idx) => <Typography key={idx}>{message}</Typography>)}
                </Alert>
            </Snackbar>
        )}
    </Grid>
}

export default CreateSMSInvitePage;